export default "__VITE_ASSET__CwSvTnU5__"